import { InferGetStaticPropsType, NextPage } from 'next';

import {
  CompanyAnimatedSelectDocument,
  CompanyAnimatedSelectQuery,
  CompanyAnimatedSelectQueryVariables,
  CompanyHeroDocument,
  CompanyHeroQuery,
  CompanyHeroQueryVariables,
  CompanyProductImageBlockDocument,
  CompanyProductImageBlockQuery,
  CompanyProductImageBlockQueryVariables,
  CompanySeoDocument,
  CompanySeoQuery,
  CompanySeoQueryVariables,
  FooterDocument,
  FooterQuery,
  FooterQueryVariables,
  NavigationDocument,
  NavigationQuery,
  NavigationQueryVariables,
} from '@/api';
import { addApolloState, initializeApollo } from '@/api/apolloClient';
import { CompaniesPage } from '@/views/companies';

export const getStaticProps = async () => {
  const client = initializeApollo();

  // prefetch
  await client.query({ query: CompanySeoDocument });
  await client.query({ query: CompanyHeroDocument });
  await client.query({ query: CompanyAnimatedSelectDocument });
  await client.query({ query: CompanyProductImageBlockDocument });
  await client.query({ query: NavigationDocument });
  await client.query({ query: FooterDocument });

  const { data: seoData } = await client.query<
    CompanySeoQuery,
    CompanySeoQueryVariables
  >({
    query: CompanySeoDocument,
  });

  const { data: heroData } = await client.query<
    CompanyHeroQuery,
    CompanyHeroQueryVariables
  >({
    query: CompanyHeroDocument,
  });

  const { data: animatedSelectData } = await client.query<
    CompanyAnimatedSelectQuery,
    CompanyAnimatedSelectQueryVariables
  >({
    query: CompanyAnimatedSelectDocument,
  });

  const { data: productImageBlockData } = await client.query<
    CompanyProductImageBlockQuery,
    CompanyProductImageBlockQueryVariables
  >({
    query: CompanyProductImageBlockDocument,
  });

  const { data: headerData } = await client.query<
    NavigationQuery,
    NavigationQueryVariables
  >({
    query: NavigationDocument,
  });

  const { data: footerData } = await client.query<
    FooterQuery,
    FooterQueryVariables
  >({
    query: FooterDocument,
  });

  return addApolloState(client, {
    props: {
      seoData,
      heroData,
      animatedSelectData,
      productImageBlockData,
      headerData,
      footerData,
    },
  });
};

const Companies: NextPage<InferGetStaticPropsType<typeof getStaticProps>> = ({
  seoData,
  heroData,
  animatedSelectData,
  productImageBlockData,
  headerData,
  footerData,
}) => (
  <CompaniesPage
    seo={seoData?.company?.data?.attributes?.seo}
    hero={heroData?.company?.data?.attributes?.hero}
    animatedSelect={animatedSelectData?.company?.data?.attributes?.animatedSelect?.map(
      (item) => ({
        ...item,
      }),
    )}
    productImageBlock={productImageBlockData?.company?.data?.attributes?.productImageBlock?.map(
      (item) => ({
        ...item,
      }),
    )}
    header={headerData}
    footer={footerData}
  />
);

export default Companies;
